var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangefileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_34917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.99 10C14.47 10 10 14.48 10 20C10 25.52 14.47 30 19.99 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 19.99 10ZM27.47 17.16L22.46 16.73L20.46 12.02C23.67 12.21 26.37 14.29 27.47 17.16ZM22.4 23.42L20 21.98L17.61 23.42L18.24 20.7L16.13 18.87L18.91 18.63L20 16.06L21.09 18.62L23.87 18.86L21.76 20.69L22.4 23.42ZM19.54 12.02L17.54 16.74L12.52 17.17C13.62 14.29 16.32 12.2 19.54 12.02ZM12 20C12 19.36 12.08 18.74 12.23 18.14L16.02 21.42L14.91 26.17C13.13 24.7 12 22.48 12 20ZM15.84 26.82L20 24.31L24.16 26.81C22.94 27.56 21.52 28 19.99 28C18.47 28 17.05 27.56 15.84 26.82ZM25.09 26.17L23.98 21.42L27.77 18.14C27.91 18.73 28 19.36 28 20C28 22.48 26.86 24.7 25.09 26.17Z",
    fill: "#00A9E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_34917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangefileicon);
export default __webpack_public_path__ + "static/media/changefileicon.e4306816d3b75f5547927c07975504bd.svg";
export { ForwardRef as ReactComponent };